/*
* resize Window
* Function to make sure everything fits well on screen
*/
export function resizeWindow() {
    var bodyElem = $("body"),
        windowElem = $(window),
        documentElem = $(document),
        hamburgerMenuElem = $("#HamburgerMenu");

    var bannerHeight = $("#Banner").height();

    hamburgerMenuElem.css("padding-top", bannerHeight);
    hamburgerMenuElem.css("height", "auto"); // Extends the hamburger menu to fit the contents
    hamburgerMenuElem.height(documentElem.height() - bannerHeight); // Extends the hamburger menu to fill up the rest of the document
}

export function reduceWindow() {

}

export function resizeToPortalContainer() {

}
